import Vue from 'vue'
import axios from 'axios'
// import LocalStorage from 'quasar'

Vue.prototype.$axios = axios

if (localStorage.getItem('tokenBasica') !== null) {
  axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem('tokenBasica')
}
